module.exports = __webpack_public_path__ + "img/icon_profile_inactive_pc.08876765.svg";